import Vue from 'vue'
import Vuex from 'vuex'
import * as Cookie from 'tiny-cookie'
import createPersistedState from 'vuex-persistedstate'

// Static Mappings
import colors from './colors'
import automationTypes from './enums/automations'
import notificationTypes from './enums/notifications'
import reportTypes from './enums/reports'

// Modules
import booking from './booking'
import customer from './customer'

Vue.use(Vuex)

const bookingFormAutosave = createPersistedState({
  key: `bookingFormAutosave`,
  paths: ['booking.form']
})

export default new Vuex.Store({
  plugins: [
    bookingFormAutosave
  ],

  modules: {
    booking,
    customer,
  },

  state: {
    colors,
    automationTypes,
    notificationTypes,
    reportTypes,
    subdomain: '',
    portal: {
      name: '',
      subdomain: '',
      color: '',
      logo: '',
      forms: []
    },
    user: null
  },

  getters: {
    account (state, getters, rootState) {
      if (rootState.route.params.account && state.user) {
        return state.user.accounts.find(acc => acc.subdomain === rootState.route.params.account)
      } else if (state.user && state.user.accounts) {
        return state.user.accounts[0]
      } else {
        return {}
      }
    }
  },

  mutations: {
    setUser (state, user) {
      state.user = user
    },

    setAccount (state, subdomain) {
      state.subdomain = subdomain
    },

    setPortal (state, portal) {
      state.portal = portal
    },

    async logout (state) {
      await this._vm.$api.post('auth/logout')
      state.user = null
      Cookie.remove('token')
    }
  },

  actions: {
    async publishEvent ({ state }, payload) {
      console.log(payload)
    },

    async syncUser (context) {
      const { data } = await this._vm.$api.get('auth/me')
      context.commit('setUser', data.user)
    }
  }
})
